export default "__VITE_ASSET__a53a6c87__"